// Turbo submits forms via fetch, so a request that dies at the network layer never produces a
// response for Turbo to render — it fires turbo:fetch-request-error and leaves the page untouched.
// The common cause here is nginx aborting an oversized upload, which otherwise fails silently.
const TOAST_ID = 'network-error-toast'

function showNetworkErrorToast() {
  document.getElementById(TOAST_ID)?.remove()

  const toast = document.createElement('div')
  toast.id = TOAST_ID
  toast.className = 'toast toast-end toast-top z-50 p-4'
  toast.innerHTML = `
    <div role="alert" class="alert alert-error shadow-lg cursor-pointer w-auto">
      <span>Your request could not reach the server. Check your connection and try again — if you were uploading a file, it may be too large.</span>
    </div>
  `
  toast.addEventListener('click', () => toast.remove())
  document.body.appendChild(toast)
}

document.addEventListener('turbo:fetch-request-error', showNetworkErrorToast)
